import { useCallback } from 'react';
import { create } from 'zustand';

import { axiosInstanceV3 } from '@mais-retorno-front/configs/axios-config';
import { ISheetFundHeader } from '@mais-retorno-front/data-access-test-2/interfaces';
import { IFundHeader } from '@mais-retorno-front/libs/util-models';

interface IUseStore {
  header: IFundHeader;
  setHeader: (header: IFundHeader) => void;
}

const useStore = create<IUseStore>((set) => ({
  header: null,
  setHeader: (header: IFundHeader) => set({ header }),
}));

export const useSheetFundHeader = ({
  initialHeader,
}: {
  initialHeader: IFundHeader;
}) => {
  const setHeader = useStore((state) => state.setHeader);
  const fundHeader = useStore((state) => state.header);

  const updateHeader = useCallback(
    async (fundSlug: string) => {
      try {
        const { data: header } = await axiosInstanceV3.get(
          `/funds/header/${fundSlug}/full`
        );

        setHeader({ ...header, ...createClassAndSubclass(header) });

        return header;
      } catch (error) {
        return null;
      }
    },
    [setHeader]
  );

  const createClassAndSubclass = (fundHeader: ISheetFundHeader) => {
    if (!fundHeader?.fund_class?.class?.slug) {
      return {
        class: fundHeader.class,
        subclass: {
          ...fundHeader.subclass,
          slug: `${fundHeader.class.slug}/${fundHeader.subclass.slug}`,
        },
      };
    }

    return fundHeader.fund_class;
  };

  return {
    fundHeader: fundHeader || initialHeader,
    updateHeader,
  };
};
